export default __webpack_public_path__ + "static/media/enter_arrow.42808fd4.svg";